import store from "@/state/store";
let accessList = localStorage.getItem("userAccess") ? store.state.decrypt.userAccessList() : [];
let admin = store.state.decrypt.isAdmin();
let external = store.state.data.selectedCampus.isExternal;
let isNewTrack = window.AGENCY_NAME && window.AGENCY_NAME.toLowerCase() !== "ustp";
export const menuItems = [
  {
    id: 1,
    label: `Dashboards`,
    icon: "bx bxs-dashboard",
    display: true,
    isUiElement: true,
    elementID: 'dashboard-menu',
    style: '',
    subItems: [
      {
        id: 1,
        label: "Home",
        link: "/",
        parentId: 1,
        display: true,
      },
      // {
      //   id: 1,
      //   label: "Financial Review",
      //   link: "/responsibility-center/financial",
      //   parentId: 1,
      //   display: displayMenu("financial review", "delivery unit"),
      // },
      {
        id: 2,
        label: "Technical Review",
        link: "/responsibility-center/technical",
        elementID: "menu-technical-review",
        parentId: 1,
        display: displayMenu("technical review", "delivery unit"),
      },
      {
        id: 4,
        label: "BAC",
        link: "/proc/bac",
        parentId: 2,
        elementID: "menu-bac-review",
        display: true,
      },
    ]
  },
  {
    id: 2,
    label: "Delivery Unit",
    icon: "bx bx-user-pin",
    isUiElement: true,
    elementID: 'delivery-unit',
    menuID: 'menu-delivery-unit',
    display: true,
    style: '',
    subItems: [
      ...actualItems(),
      ...planningItems(),
      ...procurementItems(),
      ...supplyItems(),
      ...academicItems(),
      ...dtsOfficeItems(),
      {
        id: 3,
        label: "Request for Disbursement",
        link: "/office/request-for-disbursement",
        parentId: 2,
        display: displayMenu("request for disbursement", "delivery unit"),
      },
      {
        id: 990,
        label: "Budget Proposal",
        link: "/office/budget-proposal",
        parentId: 2,
        display: admin,
        // displayMenu("delivery unit", "delivery unit")
      },
      {
        id: 992,
        divider: true,
        parentId: 2,
        display: displayDivider([
          { Access: "request for payment", Type: "delivery unit" },
          { Access: "common files", Type: "delivery unit" },
          { Access: "department allocation", Type: "delivery unit" },
        ]),
      },
      // {
      //   id: 3,
      //   label: "Request for Payment",
      //   link: "/office/request-for-payment",
      //   parentId: 2,
      //   display: displayMenu("request for payment", "delivery unit"),
      // },
      {
        id: 5,
        label: "Common Files",
        link: "/office/common-files",
        parentId: 2,
        display: displayMenu("common files", "delivery unit"),
      },
      {
        id: 7,
        label: "Services",
        link: "/office/services",
        parentId: 4,
        display: displayMenu("services", "delivery unit"),
      },
      {
        id: 4,
        label: "Department Allocation",
        link: "/office/department-allocation",
        parentId: 2,
        display: displayMenu("department allocation", "delivery unit"),
      },
    ],
  },
  {
    id: 1211,
    label: "Department",
    icon: "bx bx-user-pin",
    isUiElement: true,
    display: displayMenu("department", "department"),
    menuID: 'menu-department',
    elementID: 'department-menu',
    style: '',
    subItems: [
      // { 
      //   id: 111,
      //   label: "Actual",
      //   parentId: 2,
      //   isUiElement: true,
      //   display: displayDivider([{ Access: "actual", Type: "department" }]),
      //   subItems: [
      //     {
      //       id: 6,
      //       elementID: "department-planning-opcr",
      //       label: external ? "WFP" : "OPCR",
      //       link: "/department/actual",
      //       parentId: 2,
      //       display: displayMenu("actual", "department"),
      //     },
      //     {
      //       id: 11,
      //       label: "Budget Item Resources",
      //       link: "/department/actual-budget-item",
      //       parentId: 1,
      //       display: displayMenu("actual", "department"),
      //     },
      //     {
      //       id: 10,
      //       label: "My Item Resources",
      //       link: "/department/item-resources",
      //       parentId: 1,
      //       display: displayMenu("actual", "department"),
      //     }
      //   ]
      // },
      { 
        id: 111,
        label: "Planning",
        parentId: 2,
        isUiElement: true,
        display: displayDivider([{ Access: "actual", Type: "department" }]),
        subItems: [
          {
            id: 1,
            elementID: "menu-planning-target",
            label: external ? "Deliverables" : "Targets",
            link: "/department/planning-targets",
            parentId: 2,
            display: displayMenu("actual", "department"),
          },
          {
            id: 2,
            elementID: "department-planning-opcr",
            label: external ? "WFP" : "DPCR",
            link: "/department/planning",
            parentId: 2,
            display: displayMenu("actual", "department"),
          },
          {
            id: 3,
            label: "Budget Item Resources",
            link: "/department/planning-budget-item",
            parentId: 1,
            display: displayDivider([{ Access: "actual", Type: "department" }]),
          },
        ]
      },
      { 
        id: 95,
        label: "Procurement",
        parentId: 2,
        isUiElement: true,
        display: displayMenu("procurement", "department"),
        elementID: 'procurement-department',
        subItems: [
          {
            id: 5,
            label: "Registry of Items",
            link: "/department/item-list",
            parentId: 2,
            display: displayMenu("procurement", "department"),
          },
          {
            id: 3,
            label: "Purchase Request",
            link: "/department/pr",
            parentId: 2,
            display: displayMenu("procurement", "department"),
          },
        ]
      },
      ...dtsDepartmentItems(),
    ],
  },
  {
    id: 3,
    label: "Finance",
    icon: "bx bx-money",
    isUiElement: true,
    display: displayMenu("finance", "finance"),
    elementID: 'finance-menu',
    style: '',
    subItems: [
      {
        id: 1,
        label: 'Budget Management',
        parentId: 3,
        isUiElement: true,
        display: displayDivider([
          { Access: "fund source", Type: "finance" },
          { Access: "allocations to object of expenditure", Type: "finance" },
          { Access: "cascaded funds", Type: "finance" },
          { Access: "cascaded lib", Type: "finance" },
          { Access: "submitted lib", Type: "finance" },
          { Access: "budget modification", Type: "finance" },
          { Access: "approved budget", Type: "finance" },
          { Access: "templates", Type: "finance" },
        ]),
        subItems: [
          {
            id: 1,
            label: "Fund Source",
            link: "/finance/fund-source",
            parentId: 1,
            display: displayMenu("fund source", "finance"),
          },
          {
            id: 2,
            label: "Allocations to Object of Expenditure",
            link: "/finance/expenditures",
            parentId: 1,
            display: displayMenu("allocations to object of expenditure", "finance"),
          },
          {
            id: 3,
            label: "Cascaded Funds",
            link: "/finance/office-budget",
            parentId: 1,
            display: displayMenu("cascaded funds", "finance"),
          },
          {
            id: 4,
            label: "Cascaded LIB",
            link: "/finance/planning/cascaded-lib",
            parentId: 1,
            display: displayMenu("cascaded lib", "finance"),
          },
          {
            id: 5,
            label: "Submitted LIB",
            link: "/finance/planning/submitted-lib",
            parentId: 1,
            display: displayMenu("submitted lib", "finance"),
          },
          {
            id: 6,
            label: "Budget Modification",
            link: "/finance/budget-modification",
            parentId: 1,
            elementID: "menu-modification-finance",
            display: displayMenu("budget modification", "finance"),
          },
          {
            id: 7,
            label: "Approved Budget",
            link: "/finance/approved-budget",
            parentId: 1,
            display: displayMenu("approved budget", "finance"),
          },
          {
            id: 8,
            label: "Templates",
            link: "/finance/templates",
            parentId: 1,
            display: displayMenu("templates", "finance"),
          },
        ]
      },
      {
        id: 2,
        label: 'Account Management',
        parentId: 3,
        isUiElement: true,
        display: displayDivider([
          // { Access: "request for obligations", Type: "finance" },
          { Access: "budget utilization request", Type: "finance" },
          { Access: "disbursement processing", Type: "finance" },
          { Access: "journals", Type: "finance" },
          { Access: "subsidiary ledger", Type: "finance" },
        ]),
        subItems: [
          // {
          //   id: 1,
          //   label: "Request for Obligations",
          //   link: "/finance/request-for-obligations",
          //   parentId: 2,
          //   display: displayMenu("request for obligations", "finance"),
          // },
          {
            id: 2,
            label: "Budget Utilization Request (BURS)",
            link: "/finance/budget-utilization-request",
            parentId: 2,
            display: displayMenu("burs", "finance"),
          },
          {
            id: 3,
            label: "Disbursement Processing",
            link: "/finance/disbursement",
            parentId: 2,
            display: displayMenu("disbursement", "finance"),
          },
          {
            id: 4,
            label: "Journal Entries",
            link: "/finance/jev",
            parentId: 2,
            display: displayMenu("jev", "finance"),
          },
          {
            id: 4,
            label: "Journals",
            link: "/finance/journals",
            parentId: 2,
            display: displayMenu("journals", "finance"),
          },
          {
            id: 5,
            label: "Subsidiary Ledger",
            link: "/finance/subsidiary-ledger",
            parentId: 2,
            display: displayMenu("subsidiary ledger", "finance"),
          },
          {
            id: 6,
            label: "General Ledger",
            link: "/finance/general-ledger",
            parentId: 2,
            display: displayMenu("general ledger", "finance"),
          },
        ]
      },
      {
        id: 3,
        label: 'Treasury',
        parentId: 3,
        isUiElement: true,
        display: displayDivider([
          { Access: "cashier", Type: "finance" },
          { Access: "collection", Type: "finance" },
          { Access: "billing", Type: "finance" },
          { Access: "fees", Type: "finance" },
        ]),
        subItems: [
          {
            id: 1,
            label: "Cash Management",
            link: "/finance/cashier",
            parentId: 3,
            display: displayMenu("cashier", "finance"),
          },
          {
            id: 2,
            label: "Collection",
            link: "/finance/collection",
            parentId: 3,
            display: displayMenu("collection", "finance"),
          },
          {
            id: 2,
            label: "Report of Collections & Deposits",
            link: "/finance/rcd",
            parentId: 3,
            display: displayMenu("rcd", "finance"),
          },
          {
            id: 3,
            label: "Billing",
            link: "/finance/billing",
            parentId: 3,
            display: displayMenu("billing", "finance"),
          },
          {
            id: 4,
            label: "Fees",
            link: "/finance/fees",
            parentId: 3,
            display: displayMenu("fees", "finance"),
          },
        ]
      },
      {
        id: 30,
        label: window.IS_SCHOOL ? "Program of Receipts & Expenditures" : "Annual Investment Plan",
        link: '/',
        click: 'generatePRE',
        parentId: 3,
        display: true
      },
      {
        id: 11,
        label: "Delivery Unit Services",
        link: "/finance/delivery-unit-services",
        parentId: 3,
        display: displayMenu("delivery unit services", "finance"),
      },
      {
        id: 20,
        divider: true,
        parentId: 3,
        display: displayDivider([{ Access: "finance settings", Type: "finance" }]),
      },
      {
        id: 21,
        label: "Settings",
        link: "/finance/settings",
        parentId: 3,
        display: displayMenu("settings", "finance"),
      },
    ],
  },
  {
    id: 5,
    label: "Performance Management",
    icon: "bx bx-notepad",
    isUiElement: true,
    display: displayMenu("planning", "planning"),
    elementID: "performance-management-menu",
    style: '',
    subItems: [
      {
        id: 1,
        label: "Strategic Goals & Outcomes",
        link: "/planning/outcome",
        parentId: 5,
        display: displayMenu("outcome", "planning"),
      },
      // {
      //   id: 2,
      //   label: "KPI List",
      //   link: "/planning/kpi-list",
      //   parentId: 5,
      //   display: displayMenu("kpi list", "planning"),
      // },
      {
        id: 32,
        label: "KPI & Targets",
        parentId: 5,
        isUiElement: true,
        display: displayMenu("pre-planning", "planning"),
        subItems: [
          {
            id: 1,
            label: "Target Template",
            link: "/planning/kpi-list",
            parentId: 32,
            display: displayMenu("target template", "planning"),
          },
          {
            id: 2,
            label: "Cascaded Planning Targets",
            link: "/planning/planning-cascaded-targets",
            parentId: 3,
            display: displayMenu("pre-planning", "planning"),
          },
          {
            id: 3,
            label: "Actual Targets",
            link: "/planning/actual-targets",
            parentId: 32,
            display: displayMenu("actual targets", "planning"),
          }
        ]
      },
      { 
        id: 3,
        label: "TPMS",
        parentId: 5,
        isUiElement: true,
        elementID: "menu-actual-review",
        display: displayMenu("targets", "planning"),
        subItems: [
          {
            id: 1,
            elementID: "menu-actual-review-pme",
            label: "PMT Secretariat Review",
            link: "/planning/targets",
            parentId: 3,
            display: displayMenu("for pme review", "planning"),
          },
          {
            id: 2,
            elementID: "menu-actual-review-pmt",
            label: "PMT Rating",
            link: "/planning/targets-rating",
            parentId: 3,
            display: displayMenu("pmt rating", "planning"),
          },
        ]
      },
      // {
      //   id: 4,
      //   label: "API List",
      //   link: "/planning/api-list",
      //   parentId: 5,
      //   display: displayMenu("api list", "planning"),
      // },
      {
        id: 12,
        label: "OPCRs",
        link: "/planning/opcrs",
        parentId: 5,
        display: displayMenu("opcrs", "planning"),
      },
      {
        id: 13,
        label: "Accomplishment Reports",
        link: "/planning/accomplishment-reports",
        parentId: 5,
        display: displayMenu("accomplishment reports", "planning"),
      },
      {
        id: 13,
        label: "Budget Proposal Template",
        link: "/planning/budget-proposal-template",
        parentId: 5,
        display: displayMenu("budget proposal template", "planning"),
      },
      {
        id: 9,
        divider: true,
        parentId: 5,
        display: displayDivider([
          { Access: "faculties", Type: "planning" },
          { Access: "research", Type: "planning" },
          { Access: "academic programs", Type: "planning" },
          { Access: "extension program", Type: "planning" },
        ]),
      },
      {
        id: 9,
        label: "Faculties",
        link: "/planning/faculties",
        parentId: 5,
        display: displayMenu("faculties", "planning"),
      },
      {
        id: 5,
        label: "Research",
        link: "/planning/research",
        parentId: 5,
        display: displayMenu("research", "planning"),
      },
      {
        id: 6,
        label: "Academic Programs",
        link: "/planning/program",
        parentId: 5,
        display: displayMenu("academic programs", "planning"),
      },
      {
        id: 8,
        label: "Extension Program",
        link: "/planning/extension-program",
        parentId: 2,
        display: displayMenu("extension program", "planning"),
      },
      {
        id: 10,
        divider: true,
        parentId: 5,
        display: displayDivider([{ Access: "settings", Type: "planning" }]),
      },
      {
        id: 8,
        label: "Staffing Pattern",
        link: "/planning/staffing-pattern",
        parentId: 5,
        display: displayMenu("staffing pattern", "planning"),
      },
      {
        id: 8,
        label: "Settings",
        link: "/planning/settings",
        parentId: 5,
        display: displayMenu("settings", "planning"),
      },
    ],
  },
  {
    id: 6,
    label: "Procurement",
    icon: "bx bx-copy-alt",
    isUiElement: true,
    elementID: 'procurement',
    display: displayMenu("procurement", "procurement"),
    style: '',
    subItems: [
      {
        id: 1,
        label: "List of Procurables",
        link: "/proc/procurables",
        parentId: 6,
        display: displayMenu("list of procurables", "procurement"),
      },
      {
        id: 2,
        label: "Annual Procurement Plan",
        link: "/proc/annual-procurement-plan",
        parentId: 6,
        display: displayMenu("annual procurement plan", "procurement"),
      },
      {
        id: 3,
        label: "Planning Resources",
        link: "/proc/pre-planning",
        parentId: 6,
        display: displayMenu("planning", "procurement"),
      },
      {
        id: 4,
        label: `${window.IS_SCHOOL ? 'Campus' : 'Main Office'} Purchase Request`,
        link: "/proc/campus-pr",
        parentId: 6,
        display: displayMenu("campus pr", "procurement"),
      },
      {
        id: 5,
        divider: true,
        parentId: 6,
        display: displayDivider([
          { Access: "purchase request migration", Type: "procurement" },
          { Access: "manage purchase request", Type: "procurement" },
          { Access: "bids and quotations", Type: "procurement" },
          { Access: "purchase order", Type: "procurement" },
          { Access: "incoming deliveries", Type: "procurement" },
        ]),
      },
      {
        id: 6,
        label: "Purchase Request Migration",
        link: "/proc/pr-migration",
        parentId: 6,
        display: displayMenu("purchase request migration", "procurement"),
      },
      {
        id: 7,
        label: "Manage Purchase Request (PR)",
        link: "/proc/manage-pr",
        parentId: 6,
        display: displayMenu("manage purchase request", "procurement"),
      },
      {
        id: 8,
        label: "Bids and Quotations (RFQ)",
        link: "/proc/bids-quotations",
        parentId: 6,
        display: displayMenu("bids and quotations", "procurement"),
      },
      {
        id: 16,
        label: "Bidding",
        link: "/proc/bidding",
        parentId: 6,
        display: displayMenu("bidding", "procurement"),
      },
      {
        id: 9,
        label: "Purchase Order (PO)",
        link: "/proc/po",
        parentId: 6,
        display: displayMenu("purchase order", "procurement"),
      },
      {
        id: 10,
        label: "Incoming Deliveries",
        link: "/proc/incoming-deliveries",
        parentId: 6,
        elementID: "menu-incoming-deliveries",
        display: displayMenu("incoming deliveries", "procurement"),
      },
      {
        id: 11,
        divider: true,
        parentId: 6,
        display: displayDivider([{ Access: "request for payment", Type: "procurement" }]),
      },
      {
        id: 13,
        label: "Item Request(s)",
        link: "/proc/item-requests",
        parentId: 6,
        display: displayMenu("item requests", "procurement"),
      },
      {
        id: 14,
        divider: true,
        parentId: 6,
        display: displayDivider([{ Access: "settings", Type: "procurement" }]),
      },
      {
        id: 15,
        label: "Settings",
        link: "/proc/settings",
        parentId: 6,
        display: displayMenu("settings", "procurement"),
      },
    ],
  },

  {
    id: 8,
    label: "Deliveries & Inspection",
    icon: "bx bx-search-alt",
    isUiElement: true,
    display: displayMenu("deliveries & inspection", "inspection"),
    style: '',
    subItems: [
      {
        id: 1,
        label: "Incoming Delivery",
        link: "/inspection/incoming",
        parentId: 8,
        display: displayMenu("incoming delivery", "inspection"),
      },
      {
        id: 3,
        label: "Inspection",
        link: "/inspection/iar",
        parentId: 8,
        display: displayMenu("inspection", "inspection"),
      },
    ],
  },

  {
    id: 7,
    label: "Supply & Assets",
    icon: "bx bx-box",
    isUiElement: true,
    display: displayMenu("supply & assets", "supply & assets"),
    style: '',
    subItems: [
      {
        id: 1,
        label: "Requisition",
        link: "/property/releasedItems",
        parentId: 7,
        display: displayMenu("released items", "supply & assets"),
      },
      {
        id: 5,
        label: "Inventory",
        link: "/property/inventory",
        parentId: 2,
        display: displayMenu("inventory", "supply & assets"),
      },
      {
        id: 2,
        label: "Properties",
        parentId: 7,
        isUiElement: true,
        display: displayMenu("properties", "supply & assets"),
        subItems: [
          {
            id: 1,
            label: "Pending",
            link: "/property/register",
            parentId: 2,
            display: displayMenu("pending", "supply & assets"),
          },
          {
            id: 2,
            label: "Un-assigned",
            link: "/property/unassigned",
            parentId: 2,
            display: displayMenu("un-assigned", "supply & assets"),
          },
          {
            id: 3,
            label: "Transfer Request",
            link: "/property/transfer",
            parentId: 2,
            display: displayMenu("transfer request", "supply & assets"),
          },
          {
            id: 3,
            label: "Return Property Request",
            link: "/property/returned",
            parentId: 2,
            display: displayMenu("return property request", "supply & assets"),
          },
          {
            id: 4,
            label: "Properties",
            link: "/property/posted",
            parentId: 2,
            display: displayMenu("properties", "supply & assets"),
          },
          {
            id: 6,
            label: "Inspection",
            link: "/property/inspection",
            parentId: 2,
            display: displayMenu("inspection", "supply & assets"),
          },
          {
            id: 7,
            label: "Disposal",
            link: "/property/disposal",
            parentId: 2,
            display: displayMenu("disposal", "supply & assets"),
          },
          {
            id: 8,
            label: "Expired",
            link: "/property/expired",
            parentId: 2,
            display: displayMenu("expired", "supply & assets"),
          },
        ],
      },
      {
        id: 3,
        label: "Stocks",
        parentId: 7,
        isUiElement: true,
        display: displayMenu("stocks", "supply & assets"),
        subItems: [
          {
            id: 1,
            label: "Stocks",
            link: "/stock/stocks",
            parentId: 3,
            display: displayMenu("stocks", "supply & assets"),
          },
          {
            id: 2,
            label: "Stock Request",
            link: "/stock/transactions",
            parentId: 3,
            display: displayMenu("stock request", "supply & assets"),
          },
        ],
      },
      {
        id: 4,
        divider: true,
        parentId: 7,
        display: displayDivider([{ Access: "settings", Type: "supply & assets" }]),
      },
      {
        id: 5,
        label: "Settings",
        link: "/property/settings",
        parentId: 7,
        display: displayMenu("settings", "supply & assets"),
      },
    ],
  },

  {
    id: 8,
    label: "Processes",
    icon: "bx bx-file",
    isUiElement: true,
    display: displayMenu("processes", "processes"),
    style: '',
    subItems: [
      {
        id: 1,
        label: "All Tracks",
        link: "/processes/all-tracks",
        parentId: 8,
        display: displayMenu("all tracks", "processes"),
      },
      {
        id: 3,
        label: "Track Status",
        link: "/processes/track-status",
        parentId: 8,
        display: displayMenu("track status", "processes"),
      },
      {
        id: 2,
        label: "Settings",
        link: "/processes/settings",
        parentId: 8,
        display: displayMenu("settings", "processes"),
      },
    ],
  },

  {
    id: 4,
    label: "Administration",
    icon: "bx bx-buildings",
    isUiElement: true,
    display: displayMenu("administration", "administration"),
    style: '',
    subItems: [
      {
        id: 1,
        label: "Delivery Units",
        link: "/administration/delivery-units",
        parentId: 4,
        display: displayMenu("delivery units", "administration"),
      },
      {
        id: 7,
        label: "External Office",
        link: "/administration/external-office",
        parentId: 4,
        display: displayMenu("external office", "administration"),
      },
      {
        id: 5,
        divider: true,
        parentId: 4,
        display: displayDivider([
          { Access: "users", Type: "administration" },
          { Access: "faculties", Type: "administration" },
          { Access: "external employees", Type: "administration" },
          { Access: "resources", Type: "administration" },
        ]),
      },
      {
        id: 2,
        label: "Users",
        link: "/administration/users",
        parentId: 4,
        display: displayMenu("users", "administration"),
      },
      {
        id: 3,
        label: "Faculties",
        link: "/administration/faculties",
        parentId: 4,
        display: displayMenu("faculties", "administration"),
      },
      {
        id: 4,
        label: "External Employees",
        link: "/administration/external-employees",
        parentId: 4,
        display: displayMenu("external employees", "administration"),
      },
      {
        id: 7,
        label: "Resources",
        link: "/administration/resources",
        parentId: 4,
        display: displayMenu("resources", "administration"),
      },
      {
        id: 5,
        divider: true,
        parentId: 4,
        display: displayDivider([{ Access: "settings", Type: "administration" }]),
      },
      {
        id: 6,
        label: "Settings",
        link: "/administration/settings",
        parentId: 4,
        display: displayMenu("settings", "administration"),
      },
    ],
  },
];
function displayMenu(menu, type) {
  let display = false;
  if (admin) {
    display = true;
  } else {
    let selectedDU = store.state.data.selectedDU;
    let user = accessList.find((x) => x.Access.toLowerCase() === menu && x.Type.toLowerCase() === type) ? true : false;
    if(type == 'delivery unit' && menu != 'technical review'){
      display = user && selectedDU.withDeliveryUnitAccess;
    }
    else display = user;
  }
  return display;
}
function displayDivider(options) {
  let display = false;
  if (admin) {
    display = true;
  } else {
    let results = [];
    options.forEach((option) => {
      results.push(accessList.find((x) => x.Access.toLowerCase() === option.Access && x.Type.toLowerCase() === option.Type) ? true : false);
    });
    display = results.includes(true) ? true : false;
  }
  return display;
}
function actualItems(){
  // if(admin){
    return [
      { 
        id: 110,
        label: "Actual",
        parentId: 2,
        isUiElement: true,
        elementID: "menu-actual",
        display: displayDivider([{ Access: "targets", Type: "delivery unit" }]),
        subItems: [
          {
            id: 1,
            elementID: "menu-actual-target",
            label: external ? "Deliverables" : "Targets",
            link: "/office/targets",
            parentId: 2,
            display: displayMenu("targets", "delivery unit"),
          },
          {
            id: 2,
            elementID: "menu-actual-opcr",
            label: external ? "WFP" : "OPCR",
            link: "/office/api",
            parentId: 2,
            display: displayMenu("opcr", "delivery unit"),
          },
          {
            id: 5,
            label: "Budget Item Resources",
            link: "/office/budget-item",
            parentId: 1,
            display: displayDivider([{ Access: "budget item resources", Type: "delivery unit" }]),
          },
          {
            id: 6,
            label: "My Item Resources",
            link: "/office/item-resources",
            parentId: 1,
            elementID: "menu-modification",
            display: displayMenu("opcr", "delivery unit"),
          }
        ]
      }
    ]
  // }else{
  //   return [{
  //     id: 110,
  //     label: "Actual",
  //     disabled: true,
  //     display: displayDivider([{ Access: "targets", Type: "delivery unit" }]),
  //     parentId: 2,
  //   },
  //   {
  //     id: 1,
  //     elementID: "menu-actual-target",
  //     label: external ? "Deliverables" : "Targets",
  //     link: "/office/targets",
  //     parentId: 2,
  //     display: displayMenu("targets", "delivery unit"),
  //   },
  //   {
  //     id: 2,
  //     elementID: "menu-actual-opcr",
  //     label: external ? "WFP" : "OPCR",
  //     link: "/office/api",
  //     parentId: 2,
  //     display: displayMenu("opcr", "delivery unit"),
  //   },
  //   {
  //     id: 5,
  //     label: "Budget Item Resources",
  //     link: "/office/budget-item",
  //     parentId: 1,
  //     display: displayDivider([{ Access: "budget item resources", Type: "delivery unit" }]),
  //   },
  //   {
  //     id: 6,
  //     label: "My Item Resources",
  //     link: "/office/item-resources",
  //     parentId: 1,
  //     elementID: "menu-modification",
  //     display: displayMenu("opcr", "delivery unit"),
  //   }]
  // }
}
function planningItems(){
  // if(admin){
    return [
      { 
        id: 111,
        label: "Planning",
        parentId: 2,
        isUiElement: true,
        elementID: "menu-planning",
        display: displayDivider([{ Access: "planning", Type: "delivery unit" }]),
        subItems: [
          {
            id: 10,
            elementID: "menu-planning-target",
            label: external ? "Deliverables" : "Targets",
            link: "/office/planning-targets",
            parentId: 2,
            display: displayMenu("planning", "delivery unit"),
          },
          {
            id: 6,
            elementID: "menu-planning-opcr",
            label: external ? "WFP" : "OPCR",
            link: "/office/planning",
            parentId: 2,
            display: displayMenu("planning", "delivery unit"),
          },
          {
            id: 11,
            label: "Budget Item Resources",
            link: "/office/planning-budget-item",
            parentId: 1,
            display: displayDivider([{ Access: "planning", Type: "delivery unit" }]),
          },
        ]
      }
    ]
}
function procurementItems(){
    return [
      { 
        id: 95,
        label: "Procurement",
        parentId: 2,
        isUiElement: true,
        display: true,
        elementID: 'procurement-menu',
        subItems: [
          {
            id: 5,
            label: "Registry of Items",
            link: "/office/item-list",
            elementID: "menu-item-list",
            parentId: 2,
            display: true,
          },
          {
            id: 3,
            label: "Purchase Request",
            link: "/office/pr",
            parentId: 2,
            elementID: "menu-pr",
            display: displayMenu("purchase request", "delivery unit"),
          },
        ]
      }
    ]
}
function supplyItems(){
    return [
      { 
        id: 1115,
        label: "Supply",
        parentId: 2,
        isUiElement: true,
        display: true,
        elementID: 'supply-menu',
        subItems: [
          {
            id: 3,
            label: "Incoming Delivery",
            link: "/office/incoming-deliveries",
            parentId: 2,
            display: true,
          },
          {
            id: 3,
            label: "Requisition",
            link: "/office/requisition",
            parentId: 2,
            elementID: "menu-property-requisition",
            display: true,
          },
          {
            id: 3,
            label: "Property List",
            link: "/office/property-list",
            parentId: 2,
            display: true,
          },
          {
            id: 3,
            label: "Stocks",
            link: "/stock/stock-request",
            parentId: 2,
            display: displayMenu("stocks", "delivery unit"),
          },
        ]
      }
    ]
}
function academicItems(){
  // if(admin){
    return [
      { 
        id: 97,
        label: "Academics",
        parentId: 2,
        isUiElement: true,
        display: displayDivider([
          { Access: "research", Type: "delivery unit" },
          { Access: "academic programs", Type: "delivery unit" },
          { Access: "extension activity", Type: "delivery unit" },
        ]),
        subItems: [
          {
            id: 7,
            label: "Research",
            link: "/office/research",
            parentId: 2,
            display: displayMenu("research", "delivery unit"),
          },
          {
            id: 8,
            label: "Academic Programs",
            link: "/office/academic-programs",
            parentId: 2,
            display: displayMenu("academic programs", "delivery unit"),
          },
          {
            id: 9,
            label: "Faculties",
            link: "/office/faculties",
            parentId: 2,
            display: displayMenu("faculties", "delivery unit"),
          },
        ]
      }
    ]
}
function dtsOfficeItems(){
  // if(admin){
    return [
      { 
        id: 97,
        label: "Process Tracking",
        parentId: 2,
        isUiElement: true,
        elementID: "dts-office-menu",
        display: true,
        subItems: [
          {
            id: 1,
            label: "Office Tracks",
            link: isNewTrack ? "/dts/office-tracks-new" : "/dts/office-tracks",
            parentId: 2,
            elementID: "du-office-tracks",
            display: true,
          },
          {
            id: 2,
            label: "Incoming Tracks",
            link: isNewTrack ? "/dts/incoming-tracks-new" : "/dts/incoming-tracks",
            parentId: 2,
            elementID: "du-incoming-tracks",
            display: true,
          },
          {
            id: 3,
            label: "Process Types",
            link: "/dts/processtype-tracks",
            parentId: 2,
            display: true,
          },
        ]
      }
    ]
}
function dtsDepartmentItems(){
    return [
      { 
        id: 98,
        label: "Process Tracking",
        parentId: 2,
        isUiElement: true,
        elementID: "dts-department-menu",
        display: true,
        subItems: [
          {
            id: 1,
            label: "Department Tracks",
            link: isNewTrack ? "/dts/dept-tracks-new" : "/dts/dept-tracks",
            parentId: 2,
            elementID: "department-office-tracks",
            display: true,
          },
          {
            id: 2,
            label: "Incoming Tracks",
            link: "/dts/dept-incoming-tracks",
            parentId: 2,
            elementID: "department-incoming-tracks",
            display: true,
          },
          {
            id: 3,
            label: "Process Types",
            link: "/dts/dept-processtype-tracks",
            parentId: 2,
            display: true,
          },
        ]
      }
    ]
}